export function validatePassport(s: string): string {
  s = formatPassport(s);
  if (s.length > 9 || !/^[A-Z0-9]+$/.test(s) || !/[0-9]/.test(s)) {
    return "Pasaporte inválido";
  }
  return "OK";
}

export function formatPassport(s: string): string {
  return s.replace(' ', '').toUpperCase();
}